import angular, { ILogService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { CurriculumService } from 'src/_candidato/public/services/CurriculumService'
import { IApiRestGestionCurriculums, ICurriculumRequestEdit, IFilaCV } from 'src/model/candidato-api'

export class CurriculumPrivService extends CurriculumService {
  CLIENT_Gestion: IApiRestGestionCurriculums

  constructor($log: ILogService, AccesoDatos: AccesoDatos) {
    super($log, AccesoDatos)

    this.CLIENT_Gestion = AccesoDatos.GestionCurr_CLIENT
  }

  sendCvEdit(cv: IFilaCV, req: ICurriculumRequestEdit) {
    return this.CLIENT_Gestion.editarFormCV(cv.cv.form_id, cv.cv.idcv, req)
  }
}

angular.module('candidato').service('CurriculumPrivService', CurriculumPrivService)
